import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es6.object.assign.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import KeyCode from 'rc-util/lib/KeyCode';
import CalendarHeader from './calendar/CalendarHeader';
import CalendarFooter from './calendar/CalendarFooter';
import { calendarMixinWrapper, calendarMixinPropTypes, calendarMixinDefaultProps } from './mixin/CalendarMixin';
import { commonMixinWrapper, propType, defaultProp } from './mixin/CommonMixin';
import DateInput from './date/DateInput';
import moment from 'moment';
import { updateValueLocale } from "../lang-utils";

var MonthCalendar = /*#__PURE__*/function (_React$Component) {
  _inherits(MonthCalendar, _React$Component);

  var _super = _createSuper(MonthCalendar);

  function MonthCalendar(props) {
    var _this;

    _classCallCheck(this, MonthCalendar);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
      if (event.target.nodeName.toLowerCase() === 'input') {
        return undefined;
      } else {
        _this.props.onKeyDown && _this.props.onKeyDown(event);
      }

      var keyCode = event.keyCode;
      var ctrlKey = event.ctrlKey || event.metaKey;
      var stateValue = _this.state.value;
      var disabledDate = _this.props.disabledDate;
      var value = stateValue;

      switch (keyCode) {
        case KeyCode.DOWN:
          value = stateValue.clone();
          value.add(3, 'months');
          break;

        case KeyCode.UP:
          value = stateValue.clone();
          value.add(-3, 'months');
          break;

        case KeyCode.LEFT:
          value = stateValue.clone();

          if (ctrlKey) {
            value.add(-1, 'years');
          } else {
            value.add(-1, 'months');
          }

          break;

        case KeyCode.RIGHT:
          value = stateValue.clone();

          if (ctrlKey) {
            value.add(1, 'years');
          } else {
            value.add(1, 'months');
          }

          break;

        case KeyCode.ENTER:
          if (!disabledDate || !disabledDate(stateValue)) {
            _this.onSelect(stateValue);
          }

          event.preventDefault();
          return 1;

        default:
          return undefined;
      }

      if (value !== stateValue) {
        _this.setValue(value);

        event.preventDefault();
        return 1;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handlePanelChange", function (_, mode) {
      if (mode !== 'date') {
        _this.setState({
          mode: mode
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onInputChange", function (value) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          format = _this$props.format;

      _this.setState({
        value: value ? value : moment()
      });

      _this.setValue(value);

      onChange && onChange(value);
    });

    _defineProperty(_assertThisInitialized(_this), "onClear", function () {
      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          format = _this$props2.format,
          onClear = _this$props2.onClear;

      _this.setState({
        value: moment()
      });

      _this.setValue(moment());

      onChange && onChange('', '');
      onClear && onClear('', '');
    });

    _this.state = {
      mode: 'month',
      value: props.value || props.defaultValue || moment(),
      selectedValue: props.selectedValue || props.defaultSelectedValue
    };
    return _this;
  }

  _createClass(MonthCalendar, [{
    key: "render",
    value: function render() {
      var props = this.props,
          state = this.state;
      var mode = state.mode,
          value = state.value;
      value = value.isValid && value.isValid() ? value : moment();
      var prefixCls = props.prefixCls,
          locale = props.locale,
          format = props.format,
          showDateInput = props.showDateInput,
          onChange = props.onChange,
          onSelect = props.onSelect,
          onClear = props.onClear,
          showMonthInput = props.showMonthInput,
          renderError = props.renderError,
          validatorFunc = props.validatorFunc,
          inputReadOnly = props.inputReadOnly;
      updateValueLocale(props.locale, value); //同步moment实例的locale值

      var children = /*#__PURE__*/React.createElement("div", {
        className: "".concat(props.prefixCls, "-month-calendar-content")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(props.prefixCls, "-month-header-wrap")
      }, showDateInput && showMonthInput ? /*#__PURE__*/React.createElement(DateInput, {
        value: value,
        prefixCls: prefixCls,
        showClear: true,
        locale: locale,
        format: format,
        onChange: this.onInputChange,
        selectedValue: value,
        onClear: this.onClear,
        inputReadOnly: inputReadOnly,
        renderError: renderError,
        validatorFunc: validatorFunc
      }) : '', /*#__PURE__*/React.createElement(CalendarHeader, {
        prefixCls: props.prefixCls,
        mode: mode,
        value: value,
        locale: props.locale,
        disabledMonth: props.disabledDate,
        monthCellRender: props.monthCellRender,
        monthCellContentRender: props.monthCellContentRender,
        onMonthSelect: this.onSelect,
        onValueChange: this.setValue,
        onPanelChange: this.handlePanelChange,
        onChange: onChange,
        onClear: onClear
      })), /*#__PURE__*/React.createElement(CalendarFooter, {
        prefixCls: props.prefixCls,
        renderFooter: props.renderFooter
      }));
      return this.renderRoot({
        className: "".concat(props.prefixCls, "-month-calendar"),
        children: children
      });
    }
  }]);

  return MonthCalendar;
}(React.Component);

_defineProperty(MonthCalendar, "propTypes", _objectSpread(_objectSpread(_objectSpread({}, calendarMixinPropTypes), propType), {}, {
  monthCellRender: PropTypes.func,
  dateCellRender: PropTypes.func,
  value: PropTypes.object,
  defaultValue: PropTypes.object,
  selectedValue: PropTypes.object,
  defaultSelectedValue: PropTypes.object,
  disabledDate: PropTypes.func
}));

_defineProperty(MonthCalendar, "defaultProps", Object.assign({
  showDateInput: false
}, defaultProp, calendarMixinDefaultProps));

export default calendarMixinWrapper(commonMixinWrapper(MonthCalendar));


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-datepicker/src/rc-calendar/MonthCalendar.js